import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';
import { NotificationType } from '@shared-services/handlers/notification.service';

export interface NotificationSnackbarData {
  title: string;
  message: string;
  type: NotificationType;
}

@Component({
  selector: 'gd-notification-snackbar',
  templateUrl: './notification-snackbar.component.html',
  styleUrls: ['./notification-snackbar.component.scss'],
  standalone: true,
  imports: [MatIconModule],
})
export class NotificationSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA)
    public data: NotificationSnackbarData,
  ) {}

  getIcon(type: NotificationType): string {
    switch (type) {
      case NotificationType.SUCCESS:
        return 'check_circle';
      case NotificationType.ERROR:
        return 'cancel';
      case NotificationType.INFO:
        return 'info';
      case NotificationType.WARNING:
        return 'warning';
      default:
        return 'notification_important';
    }
  }
}
